import { render, staticRenderFns } from "./GlyphRecognizer.vue?vue&type=template&id=edda4fd2"
import script from "./GlyphRecognizer.vue?vue&type=script&lang=js"
export * from "./GlyphRecognizer.vue?vue&type=script&lang=js"
import style0 from "./GlyphRecognizer.vue?vue&type=style&index=0&id=edda4fd2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports